<template>
  <div class="container">
    <div class="panel" style="color:white">
      <h1>404</h1>
      <h3>The {{ resource }} you're looking for is not here.</h3>
      <router-link :to="'/'">Back to the home page</router-link>
    </div>
    </div>
</template>

<script>
export default {
  props: {
    resource: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>

.container {
  margin: 0 auto;
  min-height: calc(100vh - 60px);
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 460px;
}

.panel {
  width: 30em;
}

</style>
